document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home2').forEach(section => {
    const tabs = [...section.querySelectorAll('.tab')];
    const panels = [...section.querySelectorAll('.you .panel')];
    if (!tabs.length || !panels.length) return;
    let current = 0, target = 0, frame = 0, hovered = null, mobileSelected = 0;
    const clamp = value => Math.max(0, Math.min(1, value));
    const paint = progress => {
      if (section.classList.contains('jovikids-home-categories')) {
        if (window.innerWidth <= 768) progress = mobileSelected / Math.max(panels.length - 1, 1);
        else if (hovered !== null) progress = hovered / Math.max(panels.length - 1, 1);
      }
      panels.forEach((item, i) => {
        const reveal = i === 0 ? 1 : clamp(progress * (panels.length - 1) - (i - 1));
        item.style.clipPath = `inset(${(1 - reveal) * 100}% 0% 0% 0%)`;
      });
      const active = Math.min(panels.length - 1, Math.floor(progress * panels.length * .999));
      tabs.forEach((item, i) => item.classList.toggle('on', i === active));
      if (section.classList.contains('jovikids-home-categories')) panels.forEach((item, i) => item.classList.toggle('on', i === active));
    };
    const animate = () => {
      current += (target - current) * .18;
      if (Math.abs(target - current) < .0005) current = target;
      paint(current);
      frame = current === target ? 0 : requestAnimationFrame(animate);
    };
    const moveTo = value => {
      target = clamp(value);
      if (!frame) frame = requestAnimationFrame(animate);
    };
    const metrics = () => {
      const start = window.scrollY + section.getBoundingClientRect().top;
      return { start, range: Math.max(section.offsetHeight - window.innerHeight, 1) };
    };
    const updateFromScroll = () => {
      if (window.innerWidth <= 768) return;
      const m = metrics();
      moveTo((window.scrollY - m.start) / m.range);
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => { if (section.classList.contains('jovikids-home-categories')) { hovered = index; paint(current); } else tabs.forEach((item, i) => item.classList.toggle('on', i === index)); });
      tab.addEventListener('mouseleave', () => { hovered = null; paint(current); });
      tab.addEventListener('click', event => {
        if (section.classList.contains('jovikids-home-categories') && window.innerWidth <= 768) { event.preventDefault(); mobileSelected = index; paint(current); return; }
        const m = metrics();
        window.scrollTo({ top: m.start + m.range * (index / (panels.length - 1)), behavior: 'smooth' });
      });
    });
    window.addEventListener('scroll', updateFromScroll, { passive: true });
    window.addEventListener('resize', updateFromScroll);
    paint(0);
    updateFromScroll();
  });

  document.querySelectorAll('.pdt4.pc').forEach(section => {
    const tabs = [...section.querySelectorAll('.tabs .item')];
    const panels = [...section.querySelectorAll('.you .panel')];
    tabs.forEach((tab, index) => tab.addEventListener('click', event => {
      tabs.forEach((item, i) => item.classList.toggle('on', i === index));
      panels.forEach((item, i) => item.classList.toggle('on', i === Math.min(index, panels.length - 1)));
    }));
    if (!tabs.length && section.querySelector('.g2')) {
      let second = false;
      let timer;
      const start = () => { if (!timer) timer = setInterval(() => { second = !second; section.classList.toggle('show-second', second); }, 3800); };
      const stop = () => { clearInterval(timer); timer = null; };
      new IntersectionObserver(entries => entries[0].isIntersecting ? start() : stop(), { threshold: .25 }).observe(section);
    }
  });

  const stickyBuy = document.querySelector('.exact-sticky-buy');
  const productMain = document.querySelector('.exact-product-main');
  if (stickyBuy && productMain) {
    const observer = new IntersectionObserver(entries => {
      stickyBuy.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0.05 });
    observer.observe(productMain);
  }

  document.querySelectorAll('.judgeme-product-badge').forEach(badge => badge.addEventListener('click', event => {
    const target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget.jdgm-review-widget, [data-judgeme-review-widget]') || [...document.querySelectorAll('.shopify-section')].find(section => section.querySelector('.jdgm-widget'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  document.querySelectorAll('.pdt6').forEach(section => {
    const buttons = [...section.querySelectorAll('[data-advantage-index]')];
    const descriptions = [...section.querySelectorAll('.t2-item')];
    buttons.forEach((button, index) => button.addEventListener('click', () => {
      buttons.forEach((item, i) => item.classList.toggle('on', i === index));
      descriptions.forEach((item, i) => item.classList.toggle('on', i === index));
    }));
  });
});
